export const APP_UPDATE_REQUIRED_EVENT = 'cardreplay:app-update-required'

const staleAssetPatterns = [
  /chunkloaderror/i,
  /failed to fetch dynamically imported module/i,
  /importing a module script failed/i,
  /loading chunk .+ failed/i,
  /unable to preload css/i,
]

let requiredUpdateRequested = false

export function isStaleAssetError(error: unknown) {
  const message =
    error instanceof Error
      ? `${error.name} ${error.message}`
      : typeof error === 'string'
        ? error
        : ''

  return staleAssetPatterns.some((pattern) => pattern.test(message))
}

export function requestRequiredAppUpdate() {
  requiredUpdateRequested = true
  window.dispatchEvent(new Event(APP_UPDATE_REQUIRED_EVENT))
}

export function hasRequiredAppUpdateRequest() {
  return requiredUpdateRequested
}
